// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConceptSummary_concept-summary__xMrXJ {
  background-color: var(--light-blue);
  padding: 12px;
  border-radius: 12px;
  display: flex;
  gap: 16px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__6abnA {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item__r6yqn {
  padding: 12px 20px 12px 12px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  display: flex;
  align-items: center;
  gap: 12px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--icon__sPQ5U {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--icon__sPQ5U svg {
  width: 32px;
  height: 32px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--icon__sPQ5U svg path {
  stroke: var(--accent-color-dark);
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--content__HYBqW {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--value__3Yfql {
  color: var(--accent-color-dark);
  font-size: 20px;
  font-weight: bold;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--title__KLI4S {
  color: var(--dark-grey);
  font-size: 14px;
}
.ConceptSummary_concept-summary__xMrXJ .ConceptSummary_graph__grBfy {
  flex: 1 1;
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 480px) {
  .ConceptSummary_concept-summary__xMrXJ {
    padding: 0;
    flex-direction: column;
    background-color: var(--background-color-2);
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__6abnA {
    gap: 4px;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item__r6yqn {
    padding: 0;
    border-radius: 0;
    border: 0;
    gap: 4px;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--icon__sPQ5U {
    width: 14px;
    height: 14px;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--icon__sPQ5U svg {
    width: 14px;
    height: 14px;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--content__HYBqW {
    flex-direction: row;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--value__3Yfql {
    font-size: 14px;
  }
  .ConceptSummary_concept-summary__xMrXJ .ConceptSummary_statistics__item--title__KLI4S {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/ConceptDetail/Components/ConceptSummary/ConceptSummary.module.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AACI;EACE,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;AACR;AACQ;EACE,WAAA;EACA,YAAA;AACV;AACU;EACE,gCAAA;AACZ;AAIM;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAFR;AAKM;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;AAHR;AAMM;EACE,uBAAA;EACA,eAAA;AAJR;AASE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;AAPJ;AAUE;EAhEF;IAiEI,UAAA;IACA,sBAAA;IACA,2CAAA;EAPF;EAQE;IACE,QAAA;EANJ;EAOI;IACE,UAAA;IACA,gBAAA;IACA,SAAA;IACA,QAAA;EALN;EAOM;IACE,WAAA;IACA,YAAA;EALR;EAOQ;IACE,WAAA;IACA,YAAA;EALV;EASM;IACE,mBAAA;EAPR;EAUM;IACE,eAAA;EARR;EAWM;IACE,eAAA;EATR;AACF","sourcesContent":[".concept-summary {\n  background-color: var(--light-blue);\n  padding: 12px;\n  border-radius: 12px;\n  display: flex;\n  gap: 16px;\n\n  .statistics {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &__item {\n      padding: 12px 20px 12px 12px;\n      background-color: #fff;\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      display: flex;\n      align-items: center;\n      gap: 12px;\n\n      &--icon {\n        width: 40px;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 9999px;\n\n        svg {\n          width: 32px;\n          height: 32px;\n\n          path {\n            stroke: var(--accent-color-dark);\n          }\n        }\n      }\n\n      &--content {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n      }\n\n      &--value {\n        color: var(--accent-color-dark);\n        font-size: 20px;\n        font-weight: bold;\n      }\n\n      &--title {\n        color: var(--dark-grey);\n        font-size: 14px;\n      }\n    }\n  }\n\n  .graph {\n    flex: 1;\n    display: flex;\n    align-items: center;\n  }\n\n  @media only screen and (max-width: 480px) {\n    padding: 0;\n    flex-direction: column;\n    background-color: var(--background-color-2);\n    .statistics {\n      gap: 4px;\n      &__item {\n        padding: 0;\n        border-radius: 0;\n        border: 0;\n        gap: 4px;\n\n        &--icon {\n          width: 14px;\n          height: 14px;\n\n          svg {\n            width: 14px;\n            height: 14px;\n          }\n        }\n\n        &--content {\n          flex-direction: row;\n        }\n\n        &--value {\n          font-size: 14px;\n        }\n\n        &--title {\n          font-size: 14px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"concept-summary": `ConceptSummary_concept-summary__xMrXJ`,
	"statistics": `ConceptSummary_statistics__6abnA`,
	"statistics__item": `ConceptSummary_statistics__item__r6yqn`,
	"statistics__item--icon": `ConceptSummary_statistics__item--icon__sPQ5U`,
	"statistics__item--content": `ConceptSummary_statistics__item--content__HYBqW`,
	"statistics__item--value": `ConceptSummary_statistics__item--value__3Yfql`,
	"statistics__item--title": `ConceptSummary_statistics__item--title__KLI4S`,
	"graph": `ConceptSummary_graph__grBfy`
};
export default ___CSS_LOADER_EXPORT___;
